import { useLang } from "@/i18n";

export default function LanguageSwitcher({ tone = "dark" }) {
  const { lang, setLang } = useLang();
  const isDark = tone === "dark";

  const base =
    "text-[11px] uppercase tracking-[0.25em] font-bold px-2.5 py-1 transition-colors";
  const inactive = isDark ? "text-black/40 hover:text-black" : "text-white/50 hover:text-white";
  const active = "text-[#C20E1A]";
  const divider = isDark ? "text-black/20" : "text-white/30";

  return (
    <div
      data-testid="language-switcher"
      className="inline-flex items-center select-none"
      role="group"
      aria-label="Language switcher"
    >
      <button
        type="button"
        data-testid="lang-en"
        onClick={() => setLang("en")}
        className={`${base} ${lang === "en" ? active : inactive}`}
        aria-pressed={lang === "en"}
      >
        EN
      </button>
      <span className={`${divider} text-xs`}>/</span>
      <button
        type="button"
        data-testid="lang-de"
        onClick={() => setLang("de")}
        className={`${base} ${lang === "de" ? active : inactive}`}
        aria-pressed={lang === "de"}
      >
        DE
      </button>
    </div>
  );
}
